import indexActions from "./indexActions.js"

const actions = {
	indexActions
}

export default actions